/**
 * web/src/shell/tabs.tsx — the bottom-rail tab definitions and their inline
 * 20×20 SVG icons, moved verbatim out of App.tsx (card WUHnArc6lNID).
 */
import type { TabDef } from '../components/TabBar';
import type { Tab } from './dest';

/** Inline SVG icons for the four intent tabs. 20×20, currentColor stroke. */
const Icons = {
  thread: (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 3h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
      <path d="M7 8h6M7 12h4" />
    </svg>
  ),
  us: (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="6.5" cy="6.5" r="2.5" />
      <circle cx="13.5" cy="6.5" r="2.5" />
      <path d="M3 16c0-2.5 2.5-4.5 5-4.5h4c2.5 0 5 2 5 4.5" />
    </svg>
  ),
  life: (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="2" width="14" height="16" rx="2" />
      <path d="M7 6h6M7 10h6M7 14h4" />
    </svg>
  ),
  notebook: (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 3h10a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
      <path d="M7 3v14" />
    </svg>
  ),
  /* Card 2Cium84y07TE — Search is a destination of its own (Jonathan
     2026-10-25), so it needs the same 20×20 stroke mark as the four intent
     tabs: a magnifier reads as search at 20px where a glyph would not. */
  search: (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="9" r="5" />
      <path d="M12.8 12.8 17 17" />
    </svg>
  ),
};

export const TABS: TabDef[] = [
  { key: 'thread', label: 'Thread', icon: Icons.thread },
  { key: 'us', label: 'Us', icon: Icons.us },
  { key: 'life', label: 'Life', icon: Icons.life },
  /* Card anKalYfYvokw (IA phase 2), corrected by Jonathan 2026-10-28: the
     SURFACE is still Notebook — only the link collection took the name
     Collection. The tab id stays `notebook` so every walk selector, panel id
     and deep link is unaffected by either rename. */
  { key: 'notebook', label: 'Notebook', icon: Icons.notebook },
  /* Card 2Cium84y07TE (epic BpnqEtUIYiSi, half B): Search stops being a row
     in the Explore drawer and becomes a destination in the rail itself.
     Jonathan 2026-10-25: "its own destination (tab / More entry)". The tab id
     is `search`, so `#search`, the panel id and every walk selector agree. */
  { key: 'search', label: 'Search', icon: Icons.search },
];
